import CustomImage from "@components/CustomImage";
import React, { useState } from "react";

const FilePreview = ({ item, url, error }) => {
  const [imgHolder, setImgHolder] = useState(null);

  if (!item) {
    return;
  }

  const spliter = item?.name?.split(".");
  const name = spliter[0];
  const ext = spliter[1];
  const acceptImages = ["png", "jpg", "jpeg", "jfif"];
  const isImage = acceptImages.find((image) => image === ext);

  return (
    <div
      className="flex justify-center items-center w-full relative"
      style={{ maxHeight: "195x" }}
    >
      {isImage ? (
        imgHolder ? (
          <CustomImage
            className="rounded"
            style={{ maxHeight: "150x", width: "100px" }}
            src={null}
            width={100}
            height={150}
            alt="img-preview"
          />
        ) : (
          <CustomImage
            className="rounded"
            onError={() => setImgHolder(true)}
            style={{ maxHeight: "195x" }}
            src={url}
            width={150}
            height={195}
            alt="img-preview"
          />
        )
      ) : (
        <div className="flex flex-col justify-center items-center gap-2">
          <span dir="auto" className="flex text-lg" style={{ color: "black" }}>
            {(name || "")?.substr(0, 18)?.padEnd(18, "...")}
          </span>
          <div
            className="w-40 p-2 text-center text-lg rounded-md"
            style={{
              backgroundColor: "#0366ff2e",
              color: "#0366ff",
              textTransform: "uppercase",
            }}
          >
            {ext}
          </div>
        </div>
      )}
      {error ? (
        <span
          className="absolute flex w-full bottom-1 z-10"
          style={{ color: "red" }}
        >
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default FilePreview;
